import { stringify } from 'qs';
import type { Logger } from '@devhacker/shared/libs/logger';
import { API_URL, API_TIMEOUT } from '~/constants/config';
import type { IMissPrintApi, IMissPrintPayload } from '~/types/api/missPrint';
import { createAxiosLikeFetch } from '@devhacker/shared/libs/fetch/createAxiosLikeFetch';
import { createLoggerInterceptors } from '@devhacker/shared/libs/logger';

type Params = {
  $logger: Logger;
};

export default ({ $logger }: Params): IMissPrintApi => {
  const missPrintFetch = createAxiosLikeFetch({
    baseURL: `${API_URL}/wp-json/bh-missprint-alert/v1/`,
    timeout: API_TIMEOUT,
    credentials: 'include',
    ...createLoggerInterceptors($logger, 'miss-print'),
  });

  return {
    sendAlert(payload: IMissPrintPayload) {
      return missPrintFetch('send-alert', {
        method: 'POST',
        body: stringify(payload),
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      });
    },
  };
};
